import { useTranslation } from 'react-i18next';

import { ConnectionFallback } from '../ConnectionFallback';

interface ConnectToLineProps {
  description: string;
  to: string;
}

export const ConnectToLine = ({ description, to }: ConnectToLineProps) => {
  const { t } = useTranslation('anychat');

  return (
    <ConnectionFallback
      imgSrc="/assets/anychat/connect-anychat.png"
      imgAlt={t('anychat.shared.connectToLine.alt')}
      title={t('anychat.shared.connectToLine.title')}
      description={description}
      link={to}
      linkLabel={t('anychat.shared.connectToLine.link')}
    />
  );
};
